export enum ResourceEnum {
  AccountingAccount = "accounting-account",
  AccountingPosting = "accounting-posting",
  RecurringDocument = "recurring-document",
  AccountingPostingPosition = "accounting-posting-position",
  VacantPosition = "vacant-position",
  AccountingTemplate = "accounting-template",
  Product = "product",
  Attribute = "attribute",
  Category = "category",
  Discount = "discount",
  VoucherSerie = "voucher-serie",
  PaymentMethod = "payment-method",
  Document = "document",
  RecurringDocumentSchedule = "recurring-document-schedule",
  RecurringDocumentRun = "recurring-document-run",
  DeliveryMethod = "delivery-method",
  DeliveryService = "delivery-service",
  DeliveryTariff = "delivery-tariff",
  Voucher = "voucher",
  CustomerGroup = "customer-group",
  Manufacturer = "manufacturer",
  Supplier = "supplier",
  Order = "order",
  OrderDeliveryService = "order-delivery-service",
  OrderDeliveryServicePosition = "order-delivery-service-position",
  SupplierOrder = "supplier-order",
  Language = "language",
  Country = "country",
  PriceList = "price-list",
  PriceListItem = "price-list-item",
  Customer = "customer",
  ProductGroup = "product-group",
  Marketplace = "marketplace",
  ProcessingTime = "processing-time",
  OwnerProfile = "owner-profile",
  Owner = "owner",
  Condition = "condition",
  Currency = "currency",
  Unit = "unit",
  ConfigNumber = "config-number",
  IntegrationToken = "integration-token",
  Variant = "variant",
  EventTicketTemplate = "event-ticket-template",
  WarehousePlace = "warehouse-place",
  Warehouse = "warehouse",
  User = "user",
  VariantComponent = "variant-component",
  AccountMovement = "account-movement",
  Role = "role",
  StockMove = "stock-move",
  Stock = "stock",
  StockOwner = "stock-owner",
  StockWarehouse = "stock-warehouse",
  StockWarehousePlace = "stock-warehouse-place",
  Vat = "vat",
  IntAttributeValue = "int-attribute-value",
  AttributeValue = "attribute-value",
  SelectionListAttributeValue = "selection-list-attribute-value",
  FloatAttributeValue = "float-attribute-value",
  DateAttributeValue = "date-attribute-value",
  DateTimeAttributeValue = "date-time-attribute-value",
  TextFieldAttributeValue = "text-field-attribute-value",
  BankAccount = "bank-account",
  BankTransaction = "bank-transaction",
  DocumentTemplate = "document-template",
  NotificationTemplate = "notification-template",
  NotificationMessage = "notification-message",
  EpostLetter = "epost-letter",
  NotificationSignature = "notification-signature",
  NotificationSetting = "notification-setting",
  Contact = "contact",
  MarketingCompany = "marketing-company",
  RecommendationCampaign = "recommendation-campaign",
  MarketingCouponPool = "marketing-coupon-pool",
  AnlassCampaign = "anlass-campaign",
  BrevoAccount = "brevo-account",
  BankSepa = "bank-sepa",
  Carrier = "carrier",
  NotificationRoute = "notification-route",
  Picklist = "picklist",
  Process = "process",
}

export enum LoginRouteSearchParams {
  From = "from",
  Token = "token",
  Password = "password",
  Login = "login",
}

export enum ErpId {
  Kaufbei = "01KEC8S4KYQX4XMYGA4K04BB4E",
  Stage = "01KR3CY8S10B47Q517DK66VZA9",
  Local = "01J7DYRV23XSYAP2DBASZABQJP",
  ExonnErp = "01KMZ19XDGZBCGX6H35D1B855C",
  ExonnErpStage = "01KTRCASZK1KF0H7ARG3SYEAMP",
}
